export enum LocationType {
  Physical,
  Vehicle,
  All,
}
